import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getMeters,
  newMeterReading,
  newMeterReadingClear,
  meterErrorClear,
} from '../../redux/actions/meter.actions';
import Loader from '../../components/Loader';
import OptionBox from '../../components/OptionBox';
import l10n from '../../localization';
import * as Styled from './Send.styles';
import CombinedReader from './CombinedReader';
import RegularReader from './RegularReader';

const Send = (props) => {
  const [selectedMeter, setSelectedMeter] = useState(null);
  const [selectedUserMeter, setSelectedUserMeter] = useState(null);

  useEffect(() => {
    if (!props.meters.loaded) props.getMeters();
    return () => {
      props.newMeterReadingClear();
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.meters.loaded && props.meters.result.length > 0) {
      setSelectedMeter(props.meters.result[0]);
      selectUserMeter(props.meters.result[0]);
    }
    //eslint-disable-next-line
  }, [props.meters.loaded]);

  const handleSelectMeter = (item) => {
    const filteredMeters = props.meters.result.filter(
      (meter) => meter.meterSiteCode === item.slug
    );

    if (filteredMeters.length > 0) {
      const targetMeter = filteredMeters[0];
      setSelectedMeter(targetMeter);
      selectUserMeter(targetMeter);
      props.meterErrorClear();
    }
  };

  const handleSelectUserMeter = (item) => {
    const filteredUserMeters = selectedMeter.userMeters.filter(
      (userMeter) => userMeter.meterCode === item.slug
    );

    if (filteredUserMeters.length > 0) {
      setSelectedUserMeter(filteredUserMeters[0]);
      props.newMeterReadingClear();
      props.meterErrorClear();
    }
  };

  const selectUserMeter = (meter) => {
    if (meter.userMeters && meter.userMeters.length > 0) {
      setSelectedUserMeter(meter.userMeters[0]);
      props.newMeterReadingClear();
    }
  };

  const renderReader = () => {
    if (!selectedMeter) return null;

    if (selectedMeter.combined === true)
      return <CombinedReader selectedMeter={selectedMeter} />;

    return (
      <RegularReader
        selectedMeter={selectedMeter}
        selectedUserMeter={selectedUserMeter}
      />
    );
  };

  if (!props.meters.loaded) return <Loader />;

  return (
    <React.Fragment>
      <Styled.Header>
        <Styled.HeaderTitle>{l10n.send.sendDescription}</Styled.HeaderTitle>
      </Styled.Header>
      <Styled.Filters>
        <Styled.InputWrap>
          <Styled.OptionText>{l10n.send.measurementPoint}</Styled.OptionText>
          <OptionBox
            options={[
              ...props.meters.result.map((meter) => {
                return {
                  slug: meter.meterSiteCode,
                  value: `${meter.siteAddress}`,
                };
              }),
            ]}
            loading={!props.meters.loaded || !selectedMeter}
            selected={selectedMeter ? selectedMeter.meterSiteCode : null}
            onSelect={handleSelectMeter}
          />
        </Styled.InputWrap>
        {selectedMeter && !selectedMeter.combined && (
          <Styled.InputWrap>
            <Styled.OptionText>{l10n.send.measurementMeter}</Styled.OptionText>
            <OptionBox
              options={
                selectedMeter && selectedMeter.userMeters
                  ? [
                      ...selectedMeter.userMeters.map((userMeter) => {
                        return {
                          slug: userMeter.meterCode,
                          value: `${userMeter.meterCode}`,
                        };
                      }),
                    ]
                  : []
              }
              loading={!props.meters.loaded || !selectedUserMeter}
              selected={selectedUserMeter ? selectedUserMeter.meterCode : null}
              onSelect={handleSelectUserMeter}
            />
          </Styled.InputWrap>
        )}
      </Styled.Filters>

      {renderReader()}
    </React.Fragment>
  );
};

export default connect(({ meters }) => ({ meters }), {
  getMeters,
  newMeterReading,
  newMeterReadingClear,
  meterErrorClear,
})(Send);
